import { UserRole } from "./enums";

export const userRoleLabels: Record<UserRole, string> = {
  [UserRole.User]: "User",
  [UserRole.Admin]: "Administrator",
};
